<template> 
  <div>
    <button type="button" class="button is-gray-medium" @click.prevent="showModal = !showModal">
        <span class="icon-share mr-1">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M561.938 190.06L385.94 14.107C355.79-16.043 304 5.327 304 48.047v80.703C166.04 132.9 0 159.68 0 330.05c0 73.75 38.02 134.719 97.63 173.949 37.12 24.43 85.84-10.9 72.19-54.46C145.47 371.859 157.41 330.2 304 321.66v78.28c0 42.64 51.73 64.15 81.94 33.94l175.997-175.94c18.751-18.74 18.751-49.14.001-67.88zM352 400V272.09c-164.521 1.79-277.44 33.821-227.98 191.61C88 440 48 397.01 48 330.05c0-142.242 160.819-153.39 304-154.02V48l176 176-176 176z" fill="currentColor"/></svg>  
        </span> {{ $lang.translate('track.button.share')}}
    </button>
    <Modal :active="showModal" class="padded with-backdrop size-md" @close="closeModal">
      <form @submit.prevent="sendEmail" class="form" v-if="!formSent">
        <div class="form-group">
          <input type="email" v-model="email" :placeholder="$lang.translate('track.placeholder.email')" />
        </div>
        <div class="text-right mt-2">
          <button type="submit" class="button is-orange">{{ $lang.translate('track.button.send')}}</button>
        </div>
      </form>
      <div class="message" :class="messageClass" v-else>
        {{ message }}
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import { actions } from '@/store'
export default {
  data () {
    return {
      email: '',
      showModal: false,
      formSent: false,
      message: '',
      messageClass: ''
    }
  },
  methods: {
    sendEmail() {
      actions.shareResult(this.email, window.location.href)
        .then(data => {
          this.message = data.message
          this.messageClass = data.messageClass
          this.email = ''
          this.formSent = true
        },
          error => {
            console.log(error)
          }
        )
        .catch(error => {
          console.log(error)
        })
    },
    closeModal() {
      this.showModal = false
      this.formSent = false
    }
  },
  components: {
    Modal
  }
}
</script>

<style scoped>
button {
  cursor: pointer;
}

.icon-share {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-share > span {
  max-height: 100%;
  max-width: 100%;
}

.success {
  color: #8fb70e;
}

.error {
  color: #F46113;
}

</style>